import httpGet from "./httpget";
const domain = "https://account.foxitreader.cn";

// 获取IAM用户列表
export const accounts = (config = {}) => {
  return httpGet({
    url: `${domain}/api/mine/session/accounts`,
    config
  });
};

// 切换IAM用户账号
export const switchAccount = (config = {}) => {
  return httpGet({
    url: `${domain}/api/mine/switch_account/${config.params.accountId}`,
    config
  });
};